module.exports = __webpack_public_path__ + "static/media/trend-icon-down.de288194.svg";